import UsageReport from "../components/UsageReport/UsageReport";

const USAGE_REPORT_ROUTES = [
  {
    id: 'usage_report',
    path: '/usage_report',
    component: UsageReport,
    exact: true
  }
];

export default USAGE_REPORT_ROUTES;